<div *ngIf="showForms" id="voc-form">
    <img *ngIf="id === 'vocform'" src="assets/images/voc-frame.svg" class="cursor-pointer" alt="" (click)="enableForm()" width="15px" />
    <div class="button-style" *ngIf="id === 'helpbutton'" (click)="enableHelpForm()">
        <img src="assets/images/voc-frame-white.svg" class="cursor-pointer button-icon" alt="" width="15px" />
    </div>
</div>
